/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import Fields from "./components/field";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";

export default function TaxPersonal15() {
  const { formId, formField } = form;
  const [open, setOpen] = React.useState(true);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ModalCommon open={open} setOpen={setOpen} content={<ModalContent />}>
        <Box display="flex" flexDirection="column" pb={10} gap={3} mt={2}>
          <Box textAlign="center">
            <Typography variant="h4" textTransform="uppercase">
              Bảng kê chi tiết cá nhân thuộc diện tính thuế theo biểu lũy tiến từng phần
            </Typography>
          </Box>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form id={formId} autoComplete="off">
                <Fields
                  formData={{
                    values,
                    errors,
                    touched,
                    formField,
                  }}
                />
                <TaxPersonalTable setFieldValue={setFieldValue} />
                {/* <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                  {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                </SoftButton>
              </SoftBox> */}
              </Form>
            )}
          </Formik>
        </Box>
      </ModalCommon>
    </DashboardLayout>
  );
}
